<template>
    <div>
           <!-- Hero Start -->
        <section class="bg-half bg-light d-table w-100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-center">
                        <div class="title-heading">
                            <h4>欢迎您与我们建立联系</h4>
<!--                            <nav aria-label="breadcrumb" class="d-inline-block mt-4">-->
<!--                                <ul class="breadcrumb mb-0">-->
<!--                                    <li class="breadcrumb-item"><a href="/">爱拼考</a></li>-->
<!--                                    <li class="breadcrumb-item active" aria-current="page">联系我们</li>-->
<!--                                </ul>-->
<!--                            </nav>-->
                        </div>
                    </div><!--end col-->
                    <div class="home-shape-arrow">
                        <router-link href="/contact" class="scroll-down"><i class="mdi mdi-arrow-down arrow-icon bg-light text-dark h5"></i></router-link>
                    </div>
                </div><!--end row-->
            </div> <!--end container-->
        </section><!--end section-->
        <!-- Hero End -->

        <!-- About Start -->
        <section class="section pb-0" id="contact">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-12">
                        <div class="contact-detail d-flex align-items-center">
                            <div class="contact-icon rounded-circle bg-primary text-center">
                                <i data-feather="phone" class="mdi mdi-phone icon-md-md text-white"></i>
                            </div>
                            <div class="content ml-3">
                                <h5 class="title">电话</h5>
                                <a href="tel:+86400-110-1175" class="text-primary">+86 400-110-1175</a>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div class="contact-detail d-flex align-items-center">
                            <div class="contact-icon rounded-circle bg-primary text-center">
                                <i data-feather="mail" class="mdi mdi-email icon-md-md text-white"></i>
                            </div>
                            <div class="content ml-3">
                                <h5 class="title">电邮</h5>
                                <a href="mailto:services@ipeakexam.com" class="text-primary">services@ipeakexam.com</a>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                        <div class="contact-detail d-flex align-items-center">
                            <div class="contact-icon rounded-circle bg-primary text-center">
                                <i data-feather="map-pin" class="mdi mdi-google-maps icon-md-md text-white"></i>
                            </div>
                            <div class="content ml-3">
                                <h5 class="title">地址</h5>
                                <a class="text-primary">上海市浦东新区上海浦东软件园三林园1号楼</a>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->

           
            </div><!--end container-->

            <div class="container-fluid px-0 mt-100 mt-60">
                <div class="row">
                    <div class="col-12">
                        <div class="map">

                        </div>
                    </div>
                </div>
            </div>
        </section><!--end section-->
        <!-- About End -->
    </div>
</template>
<script>


export default {
    mounted () {
        this.bMap()
    },
    methods:{
        bMap() {
            //创建和初始化地图函数：
    function initMap(){
        createMap();//创建地图
        setMapEvent();//设置地图事件
        addMapControl();//向地图添加控件
        addMarker();//向地图中添加marker
    }
    
    //创建地图函数：
    function createMap(){
        var map = new BMap.Map("dituContent");//在百度地图容器中创建一个地图
        var point = new BMap.Point(121.530059,31.125521);//定义一个中心点坐标
        map.centerAndZoom(point,17);//设定地图的中心点和坐标并将地图显示在地图容器中
        window.map = map;//将map变量存储在全局
    }
    
    //地图事件设置函数：
    function setMapEvent(){
        map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
        map.enableScrollWheelZoom();//启用地图滚轮放大缩小
        map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
        map.enableKeyboard();//启用键盘上下左右键移动地图
    }
    
    //地图控件添加函数：
    function addMapControl(){
        //向地图中添加缩放控件
	var ctrl_nav = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
	map.addControl(ctrl_nav);
        //向地图中添加缩略图控件
	var ctrl_ove = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:1});
	map.addControl(ctrl_ove);
        //向地图中添加比例尺控件
	var ctrl_sca = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
	map.addControl(ctrl_sca);
    }
    
    //标注点数组
    var markerArr = [{title:"上海考得易软件有限责任公司",content:"地址",point:"121.529861|31.12651",isOpen:0,icon:{w:21,h:21,l:0,t:0,x:6,lb:5}}
		 ];
    //创建marker
    function addMarker(){
        for(var i=0;i<markerArr.length;i++){
            var json = markerArr[i];
            var p0 = json.point.split("|")[0];
            var p1 = json.point.split("|")[1];
            var point = new BMap.Point(p0,p1);
			var iconImg = createIcon(json.icon);
            var marker = new BMap.Marker(point,{icon:iconImg});
			var iw = createInfoWindow(i);
			var label = new BMap.Label(json.title,{"offset":new BMap.Size(json.icon.lb-json.icon.x+10,-20)});
			marker.setLabel(label);
            map.addOverlay(marker);
            label.setStyle({
                        borderColor:"#808080",
                        color:"#333",
                        cursor:"pointer"
            });
			
			(function(){
				var index = i;
				var _iw = createInfoWindow(i);
				var _marker = marker;
				_marker.addEventListener("click",function(){
				    this.openInfoWindow(_iw);
			    });
			    _iw.addEventListener("open",function(){
				    _marker.getLabel().hide();
			    })
			    _iw.addEventListener("close",function(){
				    _marker.getLabel().show();
			    })
				label.addEventListener("click",function(){
				    _marker.openInfoWindow(_iw);
			    })
				if(!!json.isOpen){
					label.hide();
					_marker.openInfoWindow(_iw);
				}
			})()
        }
    }
    //创建InfoWindow
    function createInfoWindow(i){
        var json = markerArr[i];
        var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>"+json.content+"</div>");
        return iw;
    }
    //创建一个Icon
    function createIcon(json){
        var icon = new BMap.Icon("http://app.baidu.com/map/images/us_mk_icon.png", new BMap.Size(json.w,json.h),{imageOffset: new BMap.Size(-json.l,-json.t),infoWindowOffset:new BMap.Size(json.lb+5,1),offset:new BMap.Size(json.x,json.h)})
        return icon;
    }
    
    initMap();//创建和初始化地图
        }
    }
}
</script>